import { c as _c } from "react/compiler-runtime";
import { Stack, Typography } from '@mui/material';
import type { ResourceType } from '@repo/api-gw-sdk';
import { useState } from 'react';
import { ResourceTypeIndicator } from '@/components/cloudProviderIndicator';
import { MainDialog } from '@/components/dialogs/mainDialog';
import { pluralize } from '@/utils/string';
export const SupportedResourceTypesText = t0 => {
  const $ = _c(18);
  const {
    resourceTypes
  } = t0;
  const [isOpen, setIsOpen] = useState(false);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => setIsOpen(true);
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const t2 = resourceTypes?.length;
  const t3 = resourceTypes?.length;
  let t4;
  if ($[1] !== t3) {
    t4 = pluralize("resource type", t3);
    $[1] = t3;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] !== t2 || $[4] !== t4) {
    t5 = <Typography component="span" className="underline cursor-pointer" onClick={t1}>{t2}{" "}{t4}</Typography>;
    $[3] = t2;
    $[4] = t4;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      title: "Available resource types",
      onClose: () => setIsOpen(false)
    };
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      flexWrap: "wrap",
      gap: "8px 100px",
      padding: "24px 40px",
      maxHeight: "400px",
      alignContent: "flex-start"
    };
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] !== resourceTypes) {
    t8 = resourceTypes?.map(_temp);
    $[8] = resourceTypes;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] !== t8) {
    t9 = <Stack direction="column" sx={t7}>{t8}</Stack>;
    $[10] = t8;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  let t10;
  if ($[12] !== isOpen || $[13] !== t9) {
    t10 = <MainDialog isOpen={isOpen} header={t6} isLoading={false}>{t9}</MainDialog>;
    $[12] = isOpen;
    $[13] = t9;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] !== t10 || $[16] !== t5) {
    t11 = <>{t5}{t10}</>;
    $[15] = t10;
    $[16] = t5;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  return t11;
};
export const AvailableForText = t0 => {
  const $ = _c(4);
  const {
    resourceTypes
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      gap: "4px",
      alignItems: "center"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Typography align="center" sx={{
      padding: "12px 0px"
    }}>Available for</Typography>;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== resourceTypes) {
    t3 = <Stack direction="row" sx={t1}>{t2}<SupportedResourceTypesText resourceTypes={resourceTypes} /></Stack>;
    $[2] = resourceTypes;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
};
function _temp(resourceType) {
  return <ResourceTypeIndicator key={resourceType} resourceType={resourceType} />;
}